export default __webpack_public_path__ + "static/media/menu-profil.cad54129.svg";